import { render, staticRenderFns } from "./BlogHero.vue?vue&type=template&id=ae2e4e98&scoped=true&"
import script from "./BlogHero.vue?vue&type=script&lang=js&"
export * from "./BlogHero.vue?vue&type=script&lang=js&"
import style0 from "./BlogHero.vue?vue&type=style&index=0&id=ae2e4e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2e4e98",
  null
  
)

export default component.exports